/**
 * vConsole 调试工具配置
 *
 * 启用条件（满足任一即可）：
 * 1. 开发环境（import.meta.env.DEV === true）
 * 2. URL 参数 ?debug=1
 * 3. LocalStorage 中 vconsole=1
 * 4. 环境变量 VITE_DEBUG=1
 *
 * URL 参数会持久化到 LocalStorage，刷新后保持开启状态
 * 使用 ?debug=0 可关闭并清除 LocalStorage
 */
export async function initVConsole(): Promise<void> {
  const conditions = {
    // 1. 开发环境
    isDev: import.meta.env.DEV,

    // 2. URL 参数 ?debug=1
    urlDebug: new URLSearchParams(window.location.search).get('debug') === '1',

    // 3. LocalStorage 开关
    storageDebug: localStorage.getItem('vconsole') === '1',

    // 4. 环境变量控制
    envDebug: import.meta.env.VITE_DEBUG === '1',
  };

  // 处理 URL 参数的持久化
  const urlDebugValue = new URLSearchParams(window.location.search).get('debug');
  if (urlDebugValue === '1') {
    localStorage.setItem('vconsole', '1');
  } else if (urlDebugValue === '0') {
    localStorage.removeItem('vconsole');
    return; // 显式关闭时直接返回
  }

  // 判断是否启用 vConsole
  const shouldEnable =
    conditions.isDev ||
    conditions.urlDebug ||
    conditions.storageDebug ||
    conditions.envDebug;

  if (shouldEnable) {
    try {
      const VConsole = (await import('vconsole')).default;
      new VConsole();
      console.log('[vConsole] 已启用，启用条件:', conditions);
    } catch (error) {
      console.warn('[vConsole] 加载失败:', error);
    }
  }
}